import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import "./index.css";
import "./Assets/CSS/style.scss";
import "./Assets/CSS/Mobile.scss";
import "./Assets/CSS/responsive.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { SearchProvider } from "./store/context/searchContext";
import "react-loading-skeleton/dist/skeleton.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <SearchProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </SearchProvider>
  </Provider>
);
